import { IDefineCommand, ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { RegistrationNoSelectedSectionsModel } from '../models/registration_no_selected_sections_model';
import { IRegistrationSelectedSectionsModel } from '../models/registration_selected_sections_model';
import { RequestStateModel } from '../../../request_state/models/request_state_model';

export type UpdateRegistrationRequestPendingCommand = (isRequestPending: boolean) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'updateRegistrationRequestPendingCommand',
    (
      defineCommandORM: IDefineCommand,
      ngRegistrationSelectedSectionsModel: IRegistrationSelectedSectionsModel,
      ngRequestStateModel: RequestStateModel
    ) =>
      defineCommandORM('updateRegistrationRequestPendingCommand', (deferred, isRequestPending: boolean) => {
        ngRegistrationSelectedSectionsModel.write({ isRequestPending: isRequestPending });
        ngRequestStateModel.write({ isRegistrationPending: isRequestPending });
        return deferred.resolve();
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/commands/update_registration_request_pending_command.ts